import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import config from '../config';

const PAGES = new Set(['/', '/paper-rankings', '/about', '/terms', '/developers', '/mcp',
  '/developers/docs', '/account/developer']);

export function usagePage(pathname) {
  if (/^\/paper\/[^/]+\/?$/.test(pathname)) return '/paper/:paperId';
  return PAGES.has(pathname) ? pathname : null;
}

// Count signed-in route arrivals. Query/hash changes and auth-token refreshes aren't new views.
// Auth/reset/redirect/consent screens are excluded; only route templates leave the browser.
export default function PageUsage() {
  const { pathname } = useLocation();
  const { user, loading } = useAuth();
  const last = useRef(null);
  const identity = user?.uid || user?.sub;
  useEffect(() => {
    if (loading) return;
    const key = identity ? `${identity}:${pathname}` : null;
    if (last.current === key) return;
    last.current = key;
    const page = usagePage(pathname);
    if (!key || !page) return;
    const token = localStorage.getItem('authToken');
    if (!token) return;
    fetch(`${config.REACT_APP_API_URL}/account/page-view`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ page }),
      keepalive: true,
    }).catch(() => {});
  }, [identity, loading, pathname]);
  return null;
}
